/* ONE. APPARELS — THEME JS v2 */
(function(){
  'use strict';

  // HEADER SCROLL
  var header = document.getElementById('site-header');
  var isHome = document.body.classList.contains('body--home');
  var isProduct = document.body.classList.contains('body--product');
  var relatedSection = document.querySelector('.related-products');
  function updateHeader(){
    if(!header) return;
    if(isProduct && relatedSection){
      // On product pages, stay transparent over all photos;
      // turn white only when the "You might also like" section reaches the header
      var headerH = header.offsetHeight || 72;
      var trigger = relatedSection.getBoundingClientRect().top <= headerH;
      if(trigger){ header.classList.remove('site-header--transparent'); header.classList.add('site-header--white'); }
      else{ header.classList.add('site-header--transparent'); header.classList.remove('site-header--white'); }
    } else if(isProduct){
      // No related section — turn white once gallery is mostly scrolled past
      var gallery = document.querySelector('.product-gallery');
      var hH = header.offsetHeight || 72;
      var pastGallery = gallery ? (gallery.getBoundingClientRect().bottom <= hH) : (window.scrollY > window.innerHeight);
      if(pastGallery){ header.classList.remove('site-header--transparent'); header.classList.add('site-header--white'); }
      else{ header.classList.add('site-header--transparent'); header.classList.remove('site-header--white'); }
    } else if(isHome){
      var scrolled = window.scrollY > 10;
      if(scrolled){ header.classList.remove('site-header--transparent'); header.classList.add('site-header--white'); }
      else{ header.classList.add('site-header--transparent'); header.classList.remove('site-header--white'); }
    } else {
      header.classList.remove('site-header--transparent');
      header.classList.add('site-header--white');
    }
  }
  var hTick = false;
  window.addEventListener('scroll', function(){
    if(hTick) return;
    hTick = true;
    window.requestAnimationFrame(function(){ updateHeader(); hTick = false; });
  }, {passive:true});
  updateHeader();

  // Anchor filter panel directly below the filter bar
  var fpPanel = document.getElementById('filterPanel');
  var fpBar = document.querySelector('.filter-bar');
  function positionFilterPanel(){
    if(!fpPanel) return;
    if(fpBar){
      var rect = fpBar.getBoundingClientRect();
      fpPanel.style.top = (rect.bottom) + 'px';
    } else {
      var h = header ? header.offsetHeight : 72;
      fpPanel.style.top = h + 'px';
    }
  }
  positionFilterPanel();
  var fpTick = false;
  function queuePositionFilterPanel(){
    if(fpTick) return;
    fpTick = true;
    window.requestAnimationFrame(function(){ positionFilterPanel(); fpTick = false; });
  }
  window.addEventListener('resize', queuePositionFilterPanel, {passive:true});
  window.addEventListener('scroll', queuePositionFilterPanel, {passive:true});

  // SIDE MENU
  var menuToggle = document.getElementById('menuToggle');
  var menuClose = document.getElementById('menuClose');
  var sideMenu = document.getElementById('sideMenu');
  var menuOverlay = document.getElementById('menuOverlay');

  function openMenu(){
    if(!sideMenu) return;
    sideMenu.classList.add('is-open');
    if(menuOverlay) menuOverlay.classList.add('is-visible');
    sideMenu.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    if(!sideMenu) return;
    sideMenu.classList.remove('is-open');
    if(menuOverlay) menuOverlay.classList.remove('is-visible');
    sideMenu.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }
  if(menuToggle) menuToggle.addEventListener('click', openMenu);
  if(menuClose) menuClose.addEventListener('click', closeMenu);

  // COLLECTIONS PANEL + CHEVRON
  var collectionsToggle = document.getElementById('collectionsToggle');
  var collectionsChevron = document.getElementById('collectionsChevron');
  var collectionsSubmenu = document.getElementById('collectionsSubmenu');
  var collectionsPanel = document.getElementById('collectionsPanel');
  var panelBack = document.getElementById('collectionsPanelBack');
  var panelClose = document.getElementById('collectionsPanelClose');

  if(collectionsChevron && collectionsSubmenu){
    collectionsChevron.addEventListener('click', function(){
      var isOpen = collectionsSubmenu.classList.toggle('is-open');
      collectionsChevron.setAttribute('aria-expanded', isOpen);
    });
    if(document.querySelector('.side-menu__sublink.is-active')){
      collectionsSubmenu.classList.add('is-open');
      collectionsChevron.setAttribute('aria-expanded','true');
    }
  }

  function openPanel(){
    if(!collectionsPanel) return;
    collectionsPanel.classList.add('is-open');
    collectionsPanel.setAttribute('aria-hidden','false');
    if(menuOverlay) menuOverlay.classList.add('is-visible');
  }
  function closePanel(reopen){
    if(!collectionsPanel) return;
    collectionsPanel.classList.remove('is-open');
    collectionsPanel.setAttribute('aria-hidden','true');
    if(reopen){ openMenu(); } else { closeMenu(); }
  }

  if(collectionsToggle){
    collectionsToggle.addEventListener('click', function(){
      closeMenu();
      setTimeout(openPanel, 60);
    });
  }
  if(panelBack) panelBack.addEventListener('click', function(){ closePanel(true); });
  if(panelClose) panelClose.addEventListener('click', function(){ closePanel(false); });

  if(menuOverlay){
    menuOverlay.addEventListener('click', function(){
      if(collectionsPanel && collectionsPanel.classList.contains('is-open')){ closePanel(false); }
      else{ closeMenu(); }
    });
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      if(collectionsPanel && collectionsPanel.classList.contains('is-open')){ closePanel(false); }
      else{ closeMenu(); }
    }
  });

  // CART COUNT
  function updateCartCount(){
    var el = document.getElementById('cartCount');
    if(!el) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    }).catch(function(){});
  }
  updateCartCount();

  // COLLECTION CONTROLS SCROLL HIDE
  var controls = document.getElementById('collectionControls');
  if(controls){
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(!ticking){
        window.requestAnimationFrame(function(){
          var y = window.scrollY;
          var down = y > lastY;
          if(y > 60){ controls.classList.toggle('is-hidden', down); }
          else{ controls.classList.remove('is-hidden'); }
          lastY = y;
          ticking = false;
        });
        ticking = true;
      }
    }, {passive:true});
  }

  // ADD TO CART
  var addBtn = document.querySelector('.btn-add-cart');
  if(addBtn){
    addBtn.addEventListener('click', function(){
      var variantId = this.dataset.variantId;
      if(!variantId) return;
      var orig = this.textContent;
      this.disabled = true;
      this.textContent = 'Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1})})
        .then(function(r){ return r.json(); })
        .then(function(){
          addBtn.textContent = 'Added';
          updateCartCount();
          showToast('Item added to cart');
          setTimeout(function(){ addBtn.disabled=false; addBtn.textContent=orig; }, 2000);
        }).catch(function(){ addBtn.disabled=false; addBtn.textContent=orig; });
    });
  }

  // SWATCHES
  var swatches = document.querySelectorAll('.swatch');
  swatches.forEach(function(sw){
    sw.addEventListener('click', function(){
      if(this.classList.contains('is-unavailable')) return;
      var group = this.closest('.option-swatches');
      if(group) group.querySelectorAll('.swatch').forEach(function(s){ s.classList.remove('is-active'); });
      this.classList.add('is-active');
      updateVariant();
    });
  });

  function updateVariant(){
    var opts = [];
    document.querySelectorAll('.option-swatches').forEach(function(g){
      var a = g.querySelector('.swatch.is-active');
      if(a) opts.push(a.dataset.value);
    });
    if(window.productVariants){
      var match = window.productVariants.find(function(v){ return v.options.every(function(o,i){ return o===opts[i]; }); });
      if(match){
        var priceEl = document.querySelector('.product-info__price');
        if(priceEl) priceEl.textContent = formatMoney(match.price);
        if(addBtn){
          addBtn.disabled = !match.available;
          addBtn.dataset.variantId = match.id;
          addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }
  }

  // CART QTY
  document.querySelectorAll('.qty-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var dir = this.dataset.direction;
      var key = this.dataset.line;
      var qtyEl = this.closest('.cart-item__qty') && this.closest('.cart-item__qty').querySelector('.qty-count');
      if(!qtyEl||!key) return;
      var qty = parseInt(qtyEl.textContent, 10);
      if(dir==='plus') qty++;
      if(dir==='minus') qty = Math.max(0, qty-1);
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(function(){ location.reload(); }).catch(function(){});
    });
  });

  // ACCORDION
  document.querySelectorAll('.accordion__btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = this.closest('.accordion__item');
      var isOpen = item.classList.toggle('is-open');
      this.setAttribute('aria-expanded', isOpen);
    });
  });

  // TOAST
  function showToast(msg){
    var t = document.querySelector('.toast');
    if(!t){ t = document.createElement('div'); t.className='toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._to);
    t._to = setTimeout(function(){ t.classList.remove('is-visible'); }, 2800);
  }

  function formatMoney(cents){
    return '\u20b9' + (cents/100).toFixed(2);
  }

  // MOBILE FILTER BAR — collapse Filter button to icon when pills are scrolled
  var filterLeft = document.querySelector('.filter-bar__left');
  if(filterLeft){
    filterLeft.addEventListener('scroll', function(){
      if(this.scrollLeft > 4) this.classList.add('is-scrolled');
      else this.classList.remove('is-scrolled');
    }, {passive:true});
  }

  // MOBILE GRID TOGGLE (1-col default / 2-col)
  var gridToggle = document.getElementById('gridToggle');
  var pGrid = document.getElementById('productGrid');
  if(gridToggle && pGrid){
    gridToggle.querySelectorAll('.grid-toggle__btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var cols = this.dataset.grid;
        gridToggle.querySelectorAll('.grid-toggle__btn').forEach(function(b){ b.classList.remove('grid-toggle__btn--active'); });
        this.classList.add('grid-toggle__btn--active');
        if(cols === '2') pGrid.classList.add('grid--2');
        else pGrid.classList.remove('grid--2');
      });
    });
  }

  // PRODUCT GALLERY CAROUSEL
  var galleryTrack = document.getElementById('galleryTrack');
  var galleryDots = document.getElementById('galleryDots');
  if(galleryTrack && galleryDots){
    var dots = galleryDots.querySelectorAll('.product-gallery__dot');
    // click dot -> scroll to slide
    dots.forEach(function(dot){
      dot.addEventListener('click', function(){
        var i = parseInt(this.dataset.index, 10);
        var slideW = galleryTrack.clientWidth;
        galleryTrack.scrollTo({ left: slideW * i, behavior: 'smooth' });
      });
    });
    // sync active dot on scroll
    var gTick = false;
    galleryTrack.addEventListener('scroll', function(){
      if(gTick) return;
      gTick = true;
      window.requestAnimationFrame(function(){
        var idx = Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
        dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
        gTick = false;
      });
    }, {passive:true});
  }

  // MOBILE STICKY ADD-TO-CART BAR
  var mAtc = document.getElementById('mAtc');
  if(mAtc){
    var mAtcBtn = document.getElementById('mAtcBtn');
    var mAtcPanel = document.getElementById('mAtcPanel');
    var mAtcConfirm = document.getElementById('mAtcConfirm');

    // Tap "Add to Cart" -> expand size/color panel (slides open)
    if(mAtcBtn){
      mAtcBtn.addEventListener('click', function(){
        var hasOptions = mAtcPanel && mAtcPanel.querySelector('.m-atc__opt');
        if(hasOptions){
          var open = mAtc.classList.toggle('is-open');
          mAtcPanel.setAttribute('aria-hidden', !open);
        } else {
          // no variants -> add directly via existing button
          var main = document.getElementById('addToCart');
          if(main) main.click();
        }
      });
    }

    // Swatch selection inside the panel (mirror to main product swatches)
    mAtc.querySelectorAll('.m-atc__swatches').forEach(function(group){
      group.querySelectorAll('.m-atc__swatch').forEach(function(sw){
        sw.addEventListener('click', function(){
          group.querySelectorAll('.m-atc__swatch').forEach(function(s){ s.classList.remove('is-active'); });
          this.classList.add('is-active');
          // mirror selection to the main product option swatches (keeps variant logic in sync)
          var idx = group.dataset.optionIndex;
          var val = this.dataset.value;
          var mainGroup = document.querySelector('.option-swatches[data-option-index="'+idx+'"]');
          if(mainGroup){
            mainGroup.querySelectorAll('.swatch').forEach(function(s){
              if(s.dataset.value === val){ s.click(); }
            });
          }
        });
      });
    });

    // Confirm add to cart -> trigger the main add-to-cart button
    if(mAtcConfirm){
      mAtcConfirm.addEventListener('click', function(){
        var main = document.getElementById('addToCart');
        if(main) main.click();
        mAtc.classList.remove('is-open');
      });
    }

    // Tap backdrop -> close panel
    var mAtcBackdrop = document.getElementById('mAtcBackdrop');
    if(mAtcBackdrop){
      mAtcBackdrop.addEventListener('click', function(){ mAtc.classList.remove('is-open'); });
    }

    // Fade the bar once the image (80vh) is scrolled past
    var mTick = false;
    function mAtcScroll(){
      if(mTick) return;
      mTick = true;
      window.requestAnimationFrame(function(){
        var threshold = window.innerHeight * 0.425; // half of the 85vh image
        if(window.scrollY > threshold){ mAtc.classList.add('is-faded'); }
        else{ mAtc.classList.remove('is-faded'); }
        mTick = false;
      });
    }
    window.addEventListener('scroll', mAtcScroll, {passive:true});
    mAtcScroll();
  }

  // FOOTER ACCORDION (mobile only)
  var footerHeadings = document.querySelectorAll('.footer-col__heading');
  footerHeadings.forEach(function(h){
    h.addEventListener('click', function(){
      if(window.innerWidth > 768) return; // mobile only
      if(this.parentElement.classList.contains('footer-col--static')) return; // Connect stays open
      this.parentElement.classList.toggle('is-open');
    });
  });

})();
